import { RootState } from "../app/store";
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { GetRefreshToken } from "../utils/UtilTarget";
import { isEmpty, setAccessTokenInQueryParams } from "../utils/Util";
import { resetState } from "../features/nonPaymentSignature/signatureSlice";
import { datadogLogs } from '@datadog/browser-logs';
export const authFetchBaseQuery = (baseUrl: string) => {
  return fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      // Add the authorization token to the headers
      const accessToken = (getState() as RootState).auth.access_token;
      if (accessToken) {
        headers.set("Authorization", `Bearer ${accessToken}`);
      }
      return headers;
    },
  });
};

//base query operational with local storage.
const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BASE_URL,
  prepareHeaders: (headers) => {
    headers.set("Content-Type", "application/json");
    headers.set("Accept", "application/json");
    headers.set("AppAgent", "TPFrontEnd")
    let apiKey = sessionStorage.getItem("nonce");
    const accessToken = localStorage.getItem("access_token");
    if (!isEmpty(apiKey)) headers.set("X-API-KEY", apiKey);
    else headers.set("Authorization", `Bearer ${accessToken}`);
    return headers;
  },
});

// Upload base query — identical to baseQuery but omits Content-Type so the browser
// can set multipart/form-data with its generated boundary for FormData requests.
const uploadBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BASE_URL,
  prepareHeaders: (headers) => {
    headers.set("Accept", "application/json");
    headers.set("AppAgent", "TPFrontEnd");
    let apiKey = sessionStorage.getItem("nonce");
    const accessToken = localStorage.getItem("access_token");
    if (!isEmpty(apiKey)) headers.set("X-API-KEY", apiKey);
    else headers.set("Authorization", `Bearer ${accessToken}`);
    return headers;
  },
});

const makeRefreshTokenHandler = (query: ReturnType<typeof fetchBaseQuery>) =>
  async (args, api, extraOptions) => {
    let result = await query(args, api, extraOptions);
    if (result.error) {
      const requestUrl = typeof args === 'string' ? args : (args as any)?.url;
      const requestMethod = typeof args === 'string' ? 'GET' : ((args as any)?.method ?? 'GET');
      const responseData = 'error' in result.error ? undefined : (result.error as any).data;
      const errorMessage = (() => {
        if ('error' in result.error) return result.error.error;
        if (typeof responseData === 'string') return responseData;
        if (responseData && typeof responseData === 'object') return responseData.Error ?? responseData.message ?? responseData.title ?? responseData.detail;
        return undefined;
      })();
      const errorDetails = responseData?.errors ?? undefined;
      datadogLogs.logger.error('API Error', {
        httpStatus: result.error.status,
        error: errorMessage,
        errors: errorDetails,
        endpoint: requestUrl,
        method: requestMethod,
      });
      if (result.error.status === 401) {
        const refresh_token = localStorage.getItem("refresh_token");
        const success: boolean = await GetRefreshToken(refresh_token);
        if (success) {
          const refreshedAccessToken = localStorage.getItem("access_token");
          setAccessTokenInQueryParams(refreshedAccessToken);
          result = await query(args, api, extraOptions);
        } else {
          api.dispatch(resetState());
          window.location.href = "/login";
        }
      }
    }
    return result;
  };

export const baseQueryWithRefreshTokenHandler = makeRefreshTokenHandler(baseQuery);
export const uploadBaseQueryWithRefreshTokenHandler = makeRefreshTokenHandler(uploadBaseQuery);
